import { Helmet } from 'react-helmet';
import Lines from '../../components/common/Lines';
import ProgressScroll from '../../components/common/ProgressScroll';
import Cursor from '../../components/common/cusor';
import Navbar from '../../components/home-main/Navbar';
import { useParams } from 'react-router-dom';
import Footer from '../../components/home-main/Footer';
import { serviceData } from '../../l-data/services';
import Header from '@/components/services-details/Header';
import Services from '@/components/services-details/Services';

export default function LPageServicesDetails() {
  const serviceId = useParams().id;
  const service = serviceData?.find((service) => service.id === serviceId);

  return (
    <>
      <Helmet>
        <title>GCAD</title>
        <link rel="icon" href="/light/assets/imgs/fox.png" />
        <link rel="shortcut icon" href="/light/assets/imgs/fox.png" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />

        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header service={service}/>
                <div className="padded-container">
                <Services service={service}/>
                </div>
            </main>
            <Footer />
          </div>
        </div>
      </>
    </>
  );
}
